/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ChatAvatarComponent from '../ChatAvatarComponent';
import moment from 'moment';
import { useEffect, useRef } from 'react';
import { useAppDispatch } from '../../../../../redux/hooks';
import _ from 'lodash';
import { acsMessageNotificationActions } from '../../../../../redux/slices/acs-message-notifications/acsMessageNotificationsSlice';
import ChatUnreadNotificationsBox from '../ChatUnreadNotificationsBox';
import { API } from '../../../../../api';

/** Chat person */
interface IChatPerson {
  type: 'personal-thread' | 'personal-user' | 'group-thread';
  name: string;
  threadId?: string;
  communicationUserId?: string;
  activeThreadId: string;
  activeCommId?: string;
  image?: string;
  index?: any;
  lastMessageReceivedOn?: string;
  lstMessage: any;
  lstMessageUserName: any;
  loading?: boolean;
  unReadMessageCount: any;
  deleted?: boolean;
  messageType?: string;
}

const ChatPerson: React.FC<IChatPerson> = ({
  type,
  name,
  threadId,
  communicationUserId,
  activeThreadId,
  activeCommId,
  image,
  index,
  lstMessage,
  lstMessageUserName,
  lastMessageReceivedOn,
  unReadMessageCount,
  loading,
  deleted,
  messageType = 'text'
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const handleClickOnChannel = async () => {
    switch (type) {
      case 'personal-thread':
        localStorage.setItem('acsdetails', JSON.stringify({ name: name }));
        dispatch(acsMessageNotificationActions.atnSetChatKind('chatDetails'));
        navigate(`/app/chat/?threadid=${threadId}&name=${name}&type=Chats`);
        await API.deleteMsgCount({ threadId: threadId });
        break;
      case 'personal-user':
        dispatch(acsMessageNotificationActions.atnSetChatKind('chatDetails'));
        navigate(`/app/chat/?commId=${communicationUserId}`);
        // console.log('communicationUserId');
        // await API.deleteMsgCount({ threadId: communicationUserId }).then((res) => console.log('ChatPereson-res', res));

        break;
      case 'group-thread':
        dispatch(acsMessageNotificationActions.atnSetChatKind('chatDetails'));
        navigate(`/app/chat/?threadid=${threadId}&name=${name}&type=Groups`);
        await API.deleteMsgCount({ threadId: threadId });
        break;
      default:
        break;
    }
  };

  const isActive = threadId === activeThreadId || communicationUserId === activeCommId;

  function formatMessageDate(timestamp: string) {
    const now = moment();
    const messageTime = moment(timestamp);

    if (messageTime.isSame(now, 'day')) {
      return messageTime.format('h:mm A');
    } else if (messageTime.isSame(now.clone().subtract(1, 'day'), 'day')) {
      return 'Yesterday';
    } else if (messageTime.isSame(now, 'week')) {
      return messageTime.format('dddd');
    } else {
      return messageTime.format('MMM D, YYYY');
    }
  }
  const refrence: React.RefObject<HTMLInputElement> = useRef(null);

  useEffect(() => {
    isActive && refrence?.current?.scrollIntoView();
  }, []);

  /** Active classes */
  return (
    <Box
      className={`chat-v2__list-item ${isActive ? 'is-active' : ''}`}
      data-testid="chat-direct-message-item"
      onClick={handleClickOnChannel}
      ref={refrence}
    >
      <Box mr={1} className="chat-v2__avatar">
        <ChatAvatarComponent
          image={image}
          firstLetter={name.slice(0, 1)}
          width="50px"
          height="50px"
          loading={loading}
          type="noStatus"
          variant="circle"
        />
      </Box>
      <Box display="flex" flexDirection="column" flexGrow={1} width="calc(100% - 60px)">
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
          <Typography variant="h5" className="chat-v2__list-title" noWrap>
            {name}
          </Typography>
          <Typography className="chat-v2__list-date" noWrap>
            {lastMessageReceivedOn ? formatMessageDate(lastMessageReceivedOn) : null}
          </Typography>
        </Box>
        {unReadMessageCount > 0 ? (
          <Box mt={0.5}>
            <ChatUnreadNotificationsBox count={unReadMessageCount} printAres="besideChat" />
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default ChatPerson;
